import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-voice-ai-summary-card',
  templateUrl: './summary-card.component.html',
  styleUrls: ['./summary-card.component.scss'],
})
export class SummaryCardComponent {
  @Input() title: string = '';
  @Input() toolTip: string = '';
  @Input() mainText: string = '';
  @Input() value: number | string | undefined = undefined;

  get absValue(): number | string | undefined {
    if (typeof this.value === 'number') {
      return Math.abs(this.value);
    }
    return this.value;
  }
}
